const CACHE_KEY = "AUDIT_USERS_CACHE";
const CACHE_ALL_USERS_KEY = "AUDIT_ALL_USERS_CACHE";
const TTL = 10 * 24 * 60 * 60 * 1000; // 10 days

const getCache = () => {
  try {
    const data = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
    if (Date.now() - (data.t || 0) > TTL) {
      localStorage.removeItem(CACHE_KEY);
      return {};
    }
    return data.u || {};
  } catch {
    return {};
  }
};

const saveCache = users => {
  try {
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ u: { ...getCache(), ...users }, t: Date.now() })
    );
  } catch {}
};

const getAllUsersCache = () => {
  try {
    const data = JSON.parse(localStorage.getItem(CACHE_ALL_USERS_KEY) || "{}");
    if (Date.now() - (data.t || 0) > TTL) {
      localStorage.removeItem(CACHE_ALL_USERS_KEY);
      return null;
    }
    return data.users || null;
  } catch {
    return null;
  }
};

const saveAllUsersCache = users => {
  try {
    localStorage.setItem(
      CACHE_ALL_USERS_KEY,
      JSON.stringify({ users, t: Date.now() })
    );
  } catch {}
};

export const getUsersWithCache = codes => {
  const cached = getCache();
  const missing = codes.filter(c => !cached[c]);
  return { cached, missing };
};

export const cacheUsers = users => saveCache(users);

export const getCachedAllUsers = () => getAllUsersCache();

export const cacheAllUsers = users => saveAllUsersCache(users);
